module.exports = __webpack_public_path__ + "static/media/bano.dea1a408.svg";